export default function isJSONResponse(type) {
  type = type || '';
  return /application\/(.*)+json/.test(type);
}